import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { getPageBoxList as _getPageBoxList } from '@/api/modules/pageCode.js';
export default {
  props: {
    selectTextbook: {
      type: Boolean,
      default: false
    },
    hiddenSubject: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      currentSubject: {},
      // 当前选中的学科
      currentBox: {},
      // 当前选中的自学宝
      currentPrecious: {},
      // 当前选中的学习分册/练习宝
      subjectCode: 0,
      // 最后一次选择的学科
      preciousInfo: {},
      // 存用户选择过的自学宝信息
      pageBoxList: [] // 自学宝列表

    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['subjectGetters', 'userActionZxbInfo', 'studyBindSuccess'])), {}, {
    preciousName: function preciousName() {
      return this.currentSubject.zhName ? "".concat(this.currentSubject.zhName, "\xB7").concat(this.currentBox.name, "\xB7").concat(this.currentPrecious.name) : '';
    }
  }),
  watch: {
    studyBindSuccess: function studyBindSuccess() {
      this.getPageBoxList(); // 绑定自学宝成功以后调接口拿最新的数据，因为如果是在当前学科下没手动选择过自学宝，那默认要帮用户选择最新绑定的自学宝
    },
    userActionZxbInfo: {
      // 在首页左侧切换了自学宝，要更新右侧的数据
      handler: function handler(val, oldVal) {
        this.preciousInfo = JSON.parse(JSON.stringify(val));
        this.init(this.subjectCode);
      },
      deep: true
    },
    subjectGetters: {
      handler: function handler(val, oldVal) {
        this.subjectCode = val;
        var subjectCodeArr = this.pageBoxList.map(function (item) {
          return item.code;
        });

        if (oldVal === 0 || subjectCodeArr.indexOf(this.subjectCode) === -1) {
          this.getPageBoxList(); // 第一次绑定自学宝成功或绑定过之后刚登录进来时候/或者绑了新学科的自学宝点击去看看时候触发
        } else if (val !== 0 && oldVal !== 0) {
          this.init(val);
        } // 点其他学科组件切换学科后触发(第一次绑定成功之后会触发绑定成功事件，不让走这里了避免重复)

      }
    },
    selectTextbook: function selectTextbook(val) {
      // 弹框显示出来就调接口拿最新的数据
      val && this.getPageBoxList();
    }
  },
  created: function created() {
    this.subjectCode = this.subjectGetters;
    this.preciousInfo = JSON.parse(JSON.stringify(this.userActionZxbInfo));
    this.getPageBoxList(); // 刚进来就得调接口，用户没绑定过自学宝时文字要显示请选择自学宝
  },
  methods: {
    getPageBoxList: function getPageBoxList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_getPageBoxLis, resData, status, preciousName;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _getPageBoxList();

              case 2:
                _yield$_getPageBoxLis = _context.sent;
                resData = _yield$_getPageBoxLis.data;
                status = _yield$_getPageBoxLis.status;
                _this.pageBoxList = resData || [];

                if (!(status !== 1 || _this.pageBoxList.length === 0)) {
                  _context.next = 14;
                  break;
                }

                _this.currentSubject = {};
                _this.currentBox = {};
                preciousName = '请选择方法盒子';

                _this.$store.dispatch('setPreciousMessage', {});

                _this.$store.dispatch('setPreciousInfo', {});

                _this.$emit('setPreciousName', preciousName);

                return _context.abrupt("return");

              case 14:
                _this.init(_this.subjectCode);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    init: function init(subjectCode, manualSwitch) {
      var _this$pageBoxList, _this$pageBoxList2, _this$currentSubject, _this$currentSubject2, _this$currentSubject3, _this$currentSubject4, _this$currentSubject5, _this$currentSubject6, _this$currentBox$prec;

      if (subjectCode === 0) return;
      this.currentSubject = ((_this$pageBoxList = this.pageBoxList) === null || _this$pageBoxList === void 0 ? void 0 : _this$pageBoxList.find(function (item) {
        return item.code === +subjectCode;
      })) || this.pageBoxList[0]; // 获取当前学科对象

      if (!this.currentSubject) {
        this.currentSubject = {};
        return;
      }

      if (!((_this$pageBoxList2 = this.pageBoxList) !== null && _this$pageBoxList2 !== void 0 && _this$pageBoxList2.find(function (item) {
        return item.code === +subjectCode;
      }))) {
        // 学科解绑找不到了，把之前选过的都清空
        this.$store.dispatch('setPreciousInfo', {});
      }

      var selectedSubjectInfo = this.preciousInfo[subjectCode]; // 看当前学科是否手动选择过自学宝，没选过就都默认选中第一个

      var boxId = selectedSubjectInfo ? selectedSubjectInfo.box.boxId : (_this$currentSubject = this.currentSubject) === null || _this$currentSubject === void 0 ? void 0 : _this$currentSubject.boxList[0].boxId;
      this.currentBox = ((_this$currentSubject2 = this.currentSubject) === null || _this$currentSubject2 === void 0 ? void 0 : (_this$currentSubject3 = _this$currentSubject2.boxList) === null || _this$currentSubject3 === void 0 ? void 0 : _this$currentSubject3.find(function (item) {
        return item.boxId === +boxId;
      })) || ((_this$currentSubject4 = this.currentSubject) === null || _this$currentSubject4 === void 0 ? void 0 : _this$currentSubject4.boxList[0]);

      if (!this.currentBox) {
        this.currentBox = {};
        return;
      }

      var preciousType = selectedSubjectInfo ? selectedSubjectInfo.precious.type : 1;

      if (!((_this$currentSubject5 = this.currentSubject) !== null && _this$currentSubject5 !== void 0 && (_this$currentSubject6 = _this$currentSubject5.boxList) !== null && _this$currentSubject6 !== void 0 && _this$currentSubject6.find(function (item) {
        return item.boxId === boxId;
      }))) {
        // 自学宝解绑找不到了，把之前选过的都清空
        this.$store.dispatch('setPreciousInfo', {});
        preciousType = 1;
      }

      this.currentPrecious = (_this$currentBox$prec = this.currentBox.preciousList) === null || _this$currentBox$prec === void 0 ? void 0 : _this$currentBox$prec.find(function (item) {
        return item.type === preciousType;
      });
      !manualSwitch && this.setPreciousMessage(); // 点击弹框里的学科时不更新调用接口需要的数据,点其他学科组件的时候要存最新的数据调turn接口用

      this.getPreciousName();
    },
    getPreciousName: function getPreciousName() {
      var _this2 = this;

      // 取出最新的名字用来展示
      var preciousName = '';
      var preciousMessage = this.preciousInfo[this.subjectCode];

      if (!preciousMessage) {
        var _this$pageBoxList3;

        var currentSubject = ((_this$pageBoxList3 = this.pageBoxList) === null || _this$pageBoxList3 === void 0 ? void 0 : _this$pageBoxList3.find(function (item) {
          return item.code === _this2.subjectCode;
        })) || this.pageBoxList[0];
        preciousName = currentSubject !== null && currentSubject !== void 0 && currentSubject.boxList[0].name ? "".concat(currentSubject === null || currentSubject === void 0 ? void 0 : currentSubject.boxList[0].name, "\xB7\u5B66\u4E60\u5206\u518C") : '请选择方法盒子';
      } else {
        var _preciousMessage$box, _preciousMessage$prec;

        preciousName = "".concat(preciousMessage === null || preciousMessage === void 0 ? void 0 : (_preciousMessage$box = preciousMessage.box) === null || _preciousMessage$box === void 0 ? void 0 : _preciousMessage$box.name, "\xB7").concat(preciousMessage === null || preciousMessage === void 0 ? void 0 : (_preciousMessage$prec = preciousMessage.precious) === null || _preciousMessage$prec === void 0 ? void 0 : _preciousMessage$prec.name);
      }

      this.$emit('setPreciousName', preciousName);
    },
    setPreciousMessage: function setPreciousMessage() {
      var subjectBoxIdType = {
        subject: +this.currentSubject.code,
        boxId: this.currentBox.boxId,
        preciousType: this.currentPrecious.type,
        boxName: this.currentBox.name
      };
      this.$store.dispatch('setPreciousMessage', subjectBoxIdType);
    },
    selectSubject: function selectSubject(subject) {
      // 选学科
      this.init(subject.code, 'manualSwitch');
    },
    selectBox: function selectBox(box) {
      // 选自学宝
      this.currentBox = box;
      this.selectPrecious(box.preciousList[0]);
    },
    selectPrecious: function selectPrecious(precious) {
      // 选学习分册/练习宝
      this.currentPrecious = precious;
    },
    handleCancel: function handleCancel() {
      this.$emit('update:selectTextbook', false);
    },
    handleSure: function handleSure() {
      var _this$$attrs;

      if (this.pageBoxList.length === 0) {
        // 没有自学宝就只关闭弹框，不做其他操作
        this.handleCancel();
        return;
      }

      this.subjectCode = this.currentSubject.code; // 让subjectCode是最后一次选择的学科，回显数据时以它为准

      this.preciousInfo[this.subjectCode] = {
        box: this.currentBox,
        precious: this.currentPrecious
      };
      var preciousName = "".concat(this.currentBox.name, "\xB7").concat(this.currentPrecious.name);
      this.$emit('setPreciousName', preciousName);

      if ((_this$$attrs = this.$attrs) !== null && _this$$attrs !== void 0 && _this$$attrs.fromDialog) {
        // 弹框上的切换之后不立即更新，要弹框关闭之后再更新
        this.$store.dispatch('toUpdatePreciousInfo', {
          subjectCode: this.currentSubject.code,
          preciousInfo: JSON.parse(JSON.stringify(this.preciousInfo))
        });
      } else {
        this.$store.dispatch('setSubject', this.currentSubject.code);
        this.$store.dispatch('setPreciousInfo', this.preciousInfo);
      }

      this.setPreciousMessage();
      this.handleCancel();
    }
  }
};